import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col } from 'react-bootstrap';
import { getCloudImageUrl } from '../../../utils';

const CollectionLook = ({ title, children, history, category }) => {
  const [categoryUrl, setCategoryUrl] = useState('');

  useEffect(() => {
    const categoryParams =
      category === 'lifestyles'
        ? 'electronics-collectibles'
        : category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category;

    setCategoryUrl(categoryParams);
  }, [category]);

  if (window.screen.availWidth < 480) {
    return (
      <Container className="container-looks" fluid>
        <h4 className="looks-title">{title}</h4>
        <div className="looks-section">
          {children &&
            children.length > 0 &&
            children.map((item, index) => {
              return (
                <Col
                  className="col-looks"
                  style={{
                    backgroundImage: `url(${getCloudImageUrl(
                      item.default_images[0].URL,
                      800,
                    )})`,
                    marginLeft: index == 0 ? '16px' : 0,
                    marginRight: index == children.length - 1 ? '24px' : 0,
                  }}
                >
                  <a
                    target="_blank"
                    href={`/${categoryUrl}/collection/${item.slug}`}
                  >
                    <h4 className="looks-name">{item.name}</h4>
                    <h6 className="looks-description">{item.description}</h6>
                  </a>
                </Col>
              );
            })}
        </div>
      </Container>
    );
  }

  return (
    <Container className="container-looks" fluid>
      <h4 className="looks-title">{title}</h4>
      <Row className="looks-section">
        {children &&
          children.length > 0 &&
          children.map((item) => {
            return (
              <Col
                className="col-looks"
                style={{
                  backgroundImage: `url(${getCloudImageUrl(
                    item.default_images[0].URL,
                    800,
                  )})`,
                }}
              >
                <a
                  target="_blank"
                  href={`/${categoryUrl}/collection/${item.slug}`}
                >
                  <h4 className="looks-name">{item.name}</h4>
                  <h6 className="looks-description">{item.description}</h6>
                </a>
              </Col>
            );
          })}
      </Row>
    </Container>
  );
};

export default CollectionLook;
